







































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import NonZeroInput from '../../common/non-zero-input.vue'
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: {NonZeroInput},
})
export default class MoneyField extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  // mounted(){}
  // created(){}

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value: number;

  @Prop()
  public label: string;

  @Prop()
  public min!: number;

  @Prop()
  public disabled!: boolean;

	/* WILL SET THE INPUT FIELD TO EMPTY, INSTEAD OF ZERO,
	IF THE VALUE IS NOT GREATER THAN ZERO, OR IF IT'S INVALID NUMBER.
	*/
  @Prop({default:false})
  public zeroReset: boolean;

  @Prop()
  public rules: any;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  public valueLocal: number = 0;

  /* VUE WATCH */
  @Watch("value", { immediate: true })
  onValueChanged(newVal: number, oldVal: number) {
    this.valueLocal = newVal;
		this.onChange();
    // if (newVal && newVal <= 0) this.valueLocal = null;
  }

  // @Watch("valueLocal", { immediate: true })
  // onValueLocalChanged(newVal: number, oldVal: number) {
  // }

  /* VUE COMPUTED METHODS */
  // get valueLocal(): number {
  //   return this.value;
  // }
  // set valueLocal(n: number) {
  //   // var num = parseFloat(n as any);
  //   // if (isNaN(num)) num = 0;
  //   // this.$emit("input", num);
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
  public onChange(): void {
    var num = parseFloat(this.valueLocal as any);

		// console.log("incoming is ", this.valueLocal, "but parsed is", num);

		if (isNaN(num)) num=0;
    // if (isNaN(num) || num<= 0 ) {
    //   num = (this.zeroReset)? null: 0;
    // } 
		this.valueLocal = num;

		this.$emit("input", num);
  }
}
